// extracted by mini-css-extract-plugin
module.exports = {"about":"about_about__38NGA"};